module.exports = __webpack_public_path__ + "media/images/close-alternate-972f086b63b0def0740978d43780bd16.svg";